import styled from 'styled-components';

export const MultiSelectionFilterWrapper = styled.div`
  user-select: none;
`;

export const Title = styled.h3`
  display: flex;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.eclipse};

  & span {
    font-weight: normal;
    padding-left: 2px;
  }
`;

export const MultiSelectionItemsWrapper = styled.div`
  max-height: 420px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
    background-color: ${({ theme }) => theme.palette.gray};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
  }
  margin-top: 20px;

  & > div:not(:last-child) {
    margin-bottom: 15px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 20px 15px 0px 15px;
    margin: 0px;
  }
`;

export const MultiSelectionItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CollapseHeaderSubTitleStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;

export const ExtraFieldValueStyle = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  margin-right: 3px;
  text-align: end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-right: 0px;
  }
`;

export const SubTitle = styled.span`
  font-size: 14px;
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.NL300};
  font-weight: 400;
`;

export const CheckboxLabel = styled.h4`
  word-break: break-word;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.NL800};
  font-size: 14px;
  font-weight: 400;
  margin-left: 3px;
`;
export const PriceWrapper = styled.div`
  font-size: 14px;
  text-align: center;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;
